/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';
import { getApiPath } from '../../store-helpers';

const state = {
  lastEditedList: [],
  limit: 20,
  keywordFilter: '',
};

const getters = {
  lastEditeds: state => state.lastEditedList,
  limit: state => state.limit,
  keywordFilter: state => state.keywordFilter,
};

const actions = {
  fetch({ commit }, payload) {
    const limit = `&limit=${payload.limit ? payload.limit : state.limit}`;
    const type = payload.type ? `&type=${payload.type}` : '';
    let keyword = '';
    const orderBy = payload.orderBy ? `&orderBy=${payload.orderBy}` : '';
    if (payload.keyword) {
      commit(mTypes.SET_KEYWORD_FILTER, payload.keyword);
      keyword = `&q=${payload.keyword}`;
    }
    return Vue.http.get(`${getApiPath(payload.user)}/lastEdited?${type}${keyword}${limit}${orderBy}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, lastEdites) {
    state.lastEditedList = lastEdites.data;
  },
  [mTypes.SET_LIMIT](state, limit) {
    state.limit = limit;
  },
  [mTypes.SET_KEYWORD_FILTER](state, keywordFilter) {
    state.keywordFilter = keywordFilter;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/landlord/lastEditeds.js